import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../Assets/Logos/CVLogo3.png';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white">
      {/* Top Section with Tagline */}
      <div className="border-b border-slate-800">
        <div className="max-w-7xl mx-auto ">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Logo */}
            <div className="">
             <img src={logo} alt="" className='h-48 w-full object-cover' />
            </div>

            {/* Tagline */}
            <div className="flex items-start gap-2 max-w-2xl">
              <span className="text-slate-400 mt-1 flex-shrink-0">✦</span>
              <p className="text-slate-300 italic text-base md:text-lg leading-relaxed">
                Guiding businesses to grow, transform, and lead with confidence, shaping a brighter future.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-16">
          {/* Our Services */}
          <div>
            <h3 className="text-xl md:text-2xl font-semibold mb-6">Our Services</h3>
            <div className="flex items-center gap-3 mb-6">
              <svg className="w-6 h-6 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M12 2L2 7l10 5 10-5-10-5z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className="h-px bg-slate-700 flex-1"></div>
            </div>
            <ul className="space-y-4">
              <li>
                <Link 
                to="/services/software-development/custom-enterprise-software"
                onClick={()=> window.scrollTo({top:0, behavior:"smooth"})}
                className="text-slate-400 hover:text-white transition-colors text-base">
                  Software Development
                </Link>
              </li>
              <li>
                <Link 
                 to="/services/engineering-digital-solutions/lims"
                onClick={()=> window.scrollTo({top:0, behavior:"smooth"})}
                className="text-slate-400 hover:text-white transition-colors text-base">
                  Engineering Digital Solutions
                </Link>
              </li>
              <li>
                <Link 
                 to="/services/construction-tech/bim-digital-twin-systems"
                onClick={()=> window.scrollTo({top:0, behavior:"smooth"})}
                className="text-slate-400 hover:text-white transition-colors text-base">
                  Construction Tech (Project Areas)
                </Link>
              </li>
              <li>
                <Link
                 to="/services/manufacturing/smart-factory-industry-4-0-platforms"
                onClick={()=> window.scrollTo({top:0, behavior:"smooth"})}
                className="text-slate-400 hover:text-white transition-colors text-base">
                  Manufacturing
                </Link>
              </li>
              <li>
                <Link 
                 to="/services/cloud-infrastructure/virtual-desktop-infrastructure-vdi"
                onClick={()=> window.scrollTo({top:0, behavior:"smooth"})}
                className="text-slate-400 hover:text-white transition-colors text-base">
                  Cloud & Infrastructure (VDI Focus)
                </Link>
              </li>
              <li>
                <Link 
                 to="/services/data-ai-solutions/predictive-analytics"
                onClick={()=> window.scrollTo({top:0, behavior:"smooth"})}
                className="text-slate-400 hover:text-white transition-colors text-base">
                  Data & AI Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Our Contact */}
          <div>
            <h3 className="text-xl md:text-2xl font-semibold mb-6">Our Contact</h3>
            <div className="flex items-center gap-3 mb-6">
              <svg className="w-6 h-6 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M12 2L2 7l10 5 10-5-10-5z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className="h-px bg-slate-700 flex-1"></div>
            </div>
            <div className="space-y-6">
              {/* Phone */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-indigo-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium mb-1">24/7 Support:</p>
                  <a href="tel:+1 7705881660" className="text-slate-400 hover:text-white transition-colors">
                    +1 7705881660
                  </a>
                </div>
              </div>

              {/* Email */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-indigo-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium mb-1">Email Our Expert:</p>
                  <a href="mailto:Info@quantrovia.com" className="text-slate-400 hover:text-white transition-colors">
                    Info@quantrovia.com
                  </a>
                </div>
              </div>

              {/* Location */}
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-indigo-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-white font-medium mb-1">Find Our Location:</p>
                  <p className="text-slate-400">15442 Ventura BLVD STE 201-2193 SHERMAN OAKS, CA. US 91403</p>
                </div>
              </div>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-xl md:text-2xl font-semibold mb-6">Get Our Newsletter</h3>
            <div className="flex items-center gap-3 mb-6">
              <svg className="w-6 h-6 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M12 2L2 7l10 5 10-5-10-5z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17l10 5 10-5M2 12l10 5 10-5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className="h-px bg-slate-700 flex-1"></div>
            </div>
            <p className="text-slate-400 mb-6 text-base leading-relaxed">
              Sign up to receive our newest insights, industry updates, and exclusive resources straight to your inbox.
            </p>
            
            {/* Newsletter Form */}
            <form className="space-y-4">
              <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-3">
                <input
                  type="email"
                  placeholder="Your email here"
                  className="flex-1 px-6 py-3 rounded-full bg-slate-800/50 border border-slate-700 text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
                <button
                  type="submit"
                  className="px-8 py-3 bg-indigo-500 hover:bg-indigo-600 text-white font-medium rounded-full flex items-center justify-center gap-2 transition-colors whitespace-nowrap"
                >
                  Submit
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
              
              {/* Privacy Notice */}
              <div className="flex items-center gap-2 text-sm text-slate-400">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <span>All your data is protected with us</span>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <div className='space-y-2'>
            <p className="text-slate-400 text-sm text-center md:text-left">
              Copyright © 2026 Quantrovia by{' '}
              <a href="#" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                Case-Themes
              </a>
              . All Rights Reserved.
            </p>
            {/* <p className='text-slate-400 text-sm text-center md:text-left'>Design & Develop By 
                 <span
                onClick={() => window.open("https://webbocket.com/", "_blank")}
                className="text-white underline cursor-pointer hover:text-gray-200 ml-3"
              >
                Web_Bocket PVT LTD.
              </span>
            </p> */}
            
            </div>
            {/* Footer Links */}
            <div className="flex items-center gap-6 text-sm">
              <a href="#privacy" className="text-slate-400 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <span className="text-slate-600">✦</span>
              <a href="#terms" className="text-slate-400 hover:text-white transition-colors">
                Terms & Condition
              </a>
              <span className="text-slate-600">✦</span>
              <a href="#support" className="text-slate-400 hover:text-white transition-colors">
                Support
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 w-12 h-12 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-full flex items-center justify-center transition-colors shadow-lg"
        aria-label="Scroll to top"
      >
        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </button>
    </footer>
  );
};

export default Footer;